import { tooltipContext } from './chunk-RBTESKWW.js';
import { provideContext } from 'maverick.js';
import { ComponentController } from 'maverick.js/element';
import { setAttribute } from 'maverick.js/std';

var id = 0;
var TooltipController = class extends ComponentController {
  constructor(instance) {
    super(instance);
    provideContext(tooltipContext, {
      ic: this.ic.bind(this)
    });
  }
  ic(tooltipEl) {
    const tooltipId = `media-tooltip-${++id}`;
    setAttribute(this.el, "aria-describedby", tooltipId);
    setAttribute(tooltipEl, "id", tooltipId);
    setAttribute(tooltipEl, "role", "tooltip");
  }
};

export { TooltipController };
